
const state = {
    showMenu:false,
    NodeId:'',
    KBInfoId:'',
    menuList:[],
    currentNode:null,
}

const getters = {

    GET_NodeId: (state) => {
        return state.nodeId
    },
    GET_showMenu: (state) => {
        return state.showMenu
    },
    GET_MenuList: (state) => {
        return state.menuList
    },
    GET_CurrentNode: (state) => {
        return state.currentNode
    }
}

const mutations = {
    SET_NodeId (state, nodeId) {
        state.nodeId = nodeId;
    },
    SET_MenuList (state, menuList) {
        state.menuList = menuList
    },
    SET_CurrentNode (state, currentNode) {
        state.currentNode = currentNode
    }
}

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js